// This file is automatically generated. Do not edit it directly.
import { createClient } from "@supabase/supabase-js";
import type { Database } from "./types";

const EXPECTED_SUPABASE_PROJECT_REF = "mazctipdafpvltawqwzx";
const EXPECTED_SUPABASE_URL = `https://${EXPECTED_SUPABASE_PROJECT_REF}.supabase.co`;

const SUPABASE_URL = import.meta.env.VITE_SUPABASE_URL as string;

const SUPABASE_PUBLIC_KEY =
  (import.meta.env.VITE_SUPABASE_PUBLISHABLE_KEY as string) ||
  (import.meta.env.VITE_SUPABASE_ANON_KEY as string);

if (!SUPABASE_URL) {
  throw new Error("Missing VITE_SUPABASE_URL in environment variables.");
}

if (SUPABASE_URL !== EXPECTED_SUPABASE_URL) {
  throw new Error(
    `BailBuddies refused to start with unexpected Supabase project: ${SUPABASE_URL}. Expected ${EXPECTED_SUPABASE_URL}.`,
  );
}

if (!SUPABASE_PUBLIC_KEY) {
  throw new Error(
    "Missing VITE_SUPABASE_PUBLISHABLE_KEY (or legacy VITE_SUPABASE_ANON_KEY) in environment variables.",
  );
}

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLIC_KEY, {
  auth: {
    persistSession: true,
    autoRefreshToken: true,
    // PKCE code exchange is handled explicitly by /auth/callback.
    // Keeping this false prevents Supabase from racing the callback page and
    // consuming the stored code verifier before exchangeCodeForSession runs.
    detectSessionInUrl: false,
    flowType: "pkce",
  },
});
